<template>
  <div class="efp">
    <div class="efp-inner">
      <div class="efpTitle">eFP Browser</div>
      <div style="width: 1200px; margin: 40px auto;">
        <el-form ref="form1" class="efp_form" :inline="true" :model="Eplant_form">
          <el-form-item label="Species">
            <el-select size="large" style="width:150px;" v-model="Eplant_form.species" @change="SpeciesChange" placeholder="Choose">
              <el-option v-for="(item, index) in firstSpeciesOptions" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="lncRNA ID">
            <el-input v-model="Eplant_form.lncRNA_id" @blur="lncRnaChange" size="large" style="width:150px;" placeholder="Please enter the content"></el-input>
          </el-form-item>
          <el-form-item label="SRA Study">
            <el-select size="large" style="width:150px;" clearable v-model="Eplant_form.SRA_Study" @change="SRA_StudyChange" placeholder="Choose">
              <el-option v-for="(item, index) in SRA_StudyOptions" :key="index" :label="item.sra_study" :value="item.sra_study">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Treatment">
            <el-select size="large" style="width:150px;" v-model="Eplant_form.trement" clearable placeholder="Choose">
              <el-option v-for="(item, index) in trementOptions" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-button class="btnSearch" @click="Example">Example</el-button>
          <el-button class="btnSearch" @click="svgData">Go</el-button>
        </el-form>
        <div class="svgClass" ref="efpPlant" v-loading="loading" v-html="stage_svg"></div>
      </div>
    </div>
  </div>
</template>

<script>
let url = {
  specie_all: "efp/specie_eft_name",
  sra_study: "species/plant_sra_study",
  efp_treatment: "efp/efp_treatment",
  svgData: "efp/efp_data",
};
export default {
  data() {
    return {
      Eplant_form: {
        species: 'Arabidopsis_thaliana',
        lncRNA_id: 'ATHA_LNC000203.1',
        SRA_Study: '',
        trement: ''
      },
      firstSpeciesOptions: [],
      SRA_StudyOptions: [],
      trementOptions: [],
      stage_svg: '',
      loading: false
    };
  },
  mounted() {
    this.specie_all()
    this.trement_all()
    this.sra_study()
    this.svgData()
  },
  methods: {
    Example() {
      console.log(this.Eplant_form.species)
      if (this.Eplant_form.species == 'Arabidopsis_thaliana') {
        this.Eplant_form = {
          species: 'Arabidopsis_thaliana',
          lncRNA_id: 'ATHA_LNC000203.1',
          SRA_Study: '',
          trement: ''
        }
      } else if (this.Eplant_form.species == 'Glycine_max') {
        this.Eplant_form = {
          species: 'Glycine_max',
          lncRNA_id: 'GMAX_LNC000009.1',
          SRA_Study: '',
          trement: ''
        }
      } else if (this.Eplant_form.species == 'Nicotiana_tabacum') {
        this.Eplant_form = {
          species: 'Nicotiana_tabacum',
          lncRNA_id: 'EL0385',
          SRA_Study: '',
          trement: ''
        }
      } else if (this.Eplant_form.species == 'Oryza_sativa') {
        this.Eplant_form = {
          species: 'Oryza_sativa',
          lncRNA_id: 'EL0297',
          SRA_Study: '',
          trement: ''
        }
      } else if (this.Eplant_form.species == 'Triticum_aestivum') {
        this.Eplant_form = {
          species: 'Triticum_aestivum',
          lncRNA_id: 'TAES_LNC000390.1',
          SRA_Study: '',
          trement: ''
        }
      } else if (this.Eplant_form.species == 'Zea_mays') {
        this.Eplant_form = {
          species: 'Zea_mays',
          lncRNA_id: 'EL1525',
          SRA_Study: '',
          trement: ''
        }
      } else if (this.Eplant_form.species == 'Solanum_lycopersicum') {
        this.Eplant_form = {
          species: 'Solanum_lycopersicum',
          lncRNA_id: 'EL0782',
          SRA_Study: '',
          trement: ''
        }
      } else if (this.Eplant_form.species == 'Solanum_tuberosum') {
        this.Eplant_form = {
          species: 'Solanum_tuberosum',
          lncRNA_id: 'STUB_LNC000003.1',
          SRA_Study: '',
          trement: ''
        }
      } else if (this.Eplant_form.species == 'Gossypium_barbadense') {
        this.Eplant_form = {
          species: 'Gossypium_barbadense',
          lncRNA_id: 'EL0711',
          SRA_Study: '',
          trement: ''
        }
      } else {
        this.Eplant_form.species = {
          species: 'Arabidopsis_thaliana',
          lncRNA_id: 'ATHA_LNC000203.1',
          SRA_Study: '',
          trement: ''
        }
      }
      // this.trement_all()
      // this.sra_study()
      // this.svgData()
    },
    SpeciesChange(val) {
      this.Eplant_form.lncRNA_id = ''
      this.trement_all()
      this.sra_study()
    },
    lncRnaChange(val) {
      this.trement_all()
      this.sra_study()
    },
    SRA_StudyChange(val) {
      this.trement_all()
    },
    specie_all() {
      this.http.get(url.specie_all, {}).then((res) => {
        if (res.data.code == 200) {
          this.firstSpeciesOptions = res.data.data;
        }
      }).catch((err) => {
        this.$message.warning(err.data.msg);
      });
    },
    sra_study() {
      this.Eplant_form.SRA_Study = ''
      this.SRA_StudyOptions = []
      let params = {
        species: this.Eplant_form.species,
        lncRNA_id: this.Eplant_form.lncRNA_id
      }
      this.http.get(url.sra_study, params).then((res) => {
        if (res.data.code == 200) {
          this.SRA_StudyOptions = res.data.data;
        }
      }).catch((err) => {
        this.$message.warning(err.response.data.error.message);
      });
    },
    trement_all() {
      this.Eplant_form.trement = ''
      this.trementOptions = []
      let params = {
        specie: this.Eplant_form.species,
        sra_study: this.Eplant_form.SRA_Study
      }
      this.http.get(url.efp_treatment, params).then((res) => {
        if (res.data.code == 200) {
          this.trementOptions = res.data.data;
        }
      }).catch((err) => {
        this.$message.warning(err.data.msg);
      });
    },
    svgData() {
      let params = {
        specie: this.Eplant_form.species,
        treatment: this.Eplant_form.trement,
        sra_study: this.Eplant_form.SRA_Study,
        lncRNA_id: this.Eplant_form.lncRNA_id
      }
      this.loading = true
      this.stage_svg = ''
      this.http.get(url.svgData, params).then((res) => {
        if (res.data.code == 200) {
          this.loading = false
          this.stage_svg = res.data.data.stage_svg
          // debugger
          Object.keys(res.data.data.stage_plant).forEach((clsItem) => {
            // 每个中有多少个部位
            this.$nextTick(function () {
              // this.$refs.efpPlant.style.height = Number(this.$refs.efpPlant.querySelector('svg').clientHeight) + 'px'
              this.$refs.efpPlant.querySelectorAll(`.${clsItem}`).forEach((item) => {
                item.style.fill = res.data.data.stage_plant[clsItem]
              });
            });
          });
        }
      }).catch((err) => {
        this.$message.warning(err.data.msg);
      });
    }
  }
};
</script>

<style scoped>
.efp {
  width: 100%;
  padding: 30px 0px;
  background: #f5f9fc;
}
.efp .efp-inner {
  width: 1240px;
  height: auto;
  padding: 0px 20px;
  padding-bottom: 20px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
}
.efp .efp-inner .efpTitle {
  height: 50px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 50px;
  border-bottom: 1px solid rgba(229, 233, 235, 1);
}
.svgClass {
  margin-top: 20px;
  width: 100%;
  height: 750px;
  /* height: 916px; */
}
.btnSearch {
  width: auto;
  height: 40px;
  background: rgba(139, 182, 68, 1);
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #fff;
  outline: none;
  border: none;
  margin-left: 15px;
}
.efp_form >>> .el-form-item__label {
  /* width:100px; */
  height: 40px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333;
  line-height: 40px;
}
</style>
